export default (props) => {
	const { url, subtitle } = props;
	return {
		url,
		subtitle,
	};
};
